import {
  IconBulb as Bulb,
  IconClipboardText as ClipboardText,
  IconClock as Clock,
  IconFiles as Files,
  IconRoute as Route,
} from "@tabler/icons-react";

export function ProblemInsightSection({ t }) {
  const icons = [ClipboardText, Clock, Route, Files];

  return (
    <section id="problem" className="relative overflow-hidden py-24 md:py-32">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_18%_20%,hsl(var(--brand)/0.1),transparent_32%),radial-gradient(circle_at_86%_72%,hsl(var(--brand)/0.08),transparent_34%)]" />

      <div className="container-x relative">
        <div className="grid gap-12 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-7">
            <div className="reveal eyebrow mb-5">{t.problemInsight.eyebrow}</div>
            <h2 className="reveal font-display text-[clamp(2rem,4.4vw,3.75rem)] font-medium leading-[1.25]">
              <span className="block">{t.problemInsight.titleA}</span>
              <span className="block text-brand">{t.problemInsight.titleB}</span>
            </h2>
          </div>

          <div className="reveal lg:col-span-5">
            <p className="text-lg leading-relaxed text-muted-foreground">
              {t.problemInsight.lead}
            </p>
            <p className="mt-6 font-sans text-sm font-semibold uppercase tracking-[0.16em] text-[hsl(var(--foreground))] dark:text-white/82">
              {t.problemInsight.sub}
            </p>
          </div>
        </div>

        <div className="mt-14 grid gap-4 md:grid-cols-2 xl:grid-cols-4">
          {t.problemInsight.cards.map((card, index) => {
            const Icon = icons[index] || ClipboardText;

            return (
              <article
                key={card.title}
                className="reveal group rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--surface)/0.78)] p-6 shadow-xl shadow-[hsl(var(--brand)/0.05)] backdrop-blur transition-all hover:-translate-y-1 hover:border-brand dark:bg-white/[0.045] dark:shadow-black/20"
                style={{ transitionDelay: `${index * 70}ms` }}
              >
                <div className="flex items-center justify-between gap-4">
                  <span className="font-mono text-sm font-semibold text-brand">
                    0{index + 1}
                  </span>
                  <span className="grid h-11 w-11 place-items-center rounded-xl bg-brand-soft text-brand dark:bg-brand/15">
                    <Icon className="h-5 w-5" />
                  </span>
                </div>
                <h3 className="mt-8 font-display text-2xl font-semibold leading-tight">
                  {card.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
                  {card.desc}
                </p>
              </article>
            );
          })}
        </div>

        <div className="reveal mt-8 rounded-2xl border border-brand/25 bg-brand-soft p-6 text-[hsl(var(--foreground))] dark:bg-brand/12 dark:text-white">
          <div className="mx-auto flex max-w-4xl flex-col items-center justify-center gap-4 text-center md:flex-row">
            <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-brand text-white">
              <Bulb className="h-5 w-5" />
            </span>
            <p className="font-display text-xl font-semibold leading-tight md:text-2xl">
              {t.problemInsight.insight}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
